// @core/api/endpoints/workflow/update_agent_tool.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AgentToolResponse,
  UpdateAgentToolRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Update agent tool
 * Updates an agent tool. Builtin tools cannot be edited.
 */
export async function UpdateAgentTool(
  tool_id: string,
  data: UpdateAgentToolRequest,
  options?: RequestOptions
): Promise<AgentToolResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/agent-tools/:tool_id`;
  requestPath = requestPath.replace(':tool_id', encodeURIComponent(tool_id));
  const requestOptions = options;
  return client.patch<AgentToolResponse>(requestPath, data, requestOptions);
}
